import { IEventService, UserActivityEventPayload } from '@price-for-profit/micro-services';
import { CLIENT_ID } from 'shared/constants';
import { UserActivityEvent } from 'shared/types';

export interface IWpsEventService {
  logUserEvent(userId: string, applicationId: string, eventDetails: UserActivityEvent): Promise<string>;
}

export class WpsEventService implements IWpsEventService {
  constructor(private eventService: IEventService) {}

  async logUserEvent(userId: string, applicationId: string, eventDetails: UserActivityEvent): Promise<string> {
    const eventPayload: UserActivityEventPayload = {
      clientId: CLIENT_ID,
      applicationId,
      userId,
      timeStamp: new Date(),
      data: eventDetails.data ?? {},
      ...eventDetails,
    };
    const event = await this.eventService.logUserActivity(eventPayload);
    return event.correlationId;
  }
}
